import { WindTurbinePersonnelSVG } from "./WindTurbinePersonnelSVG";
export default WindTurbinePersonnelSVG;
